import requests from "./httpServices.js";

class PollServices {
  /**
   * Create a new poll
   * @param data - Poll creation data
   * @returns Promise<PollResponse>
   */
  async createPoll(data) {
    try {
      const response = await requests.post(`/polls`, data);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getPolls() {
    try {
      const response = await requests.get(`/polls`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Update an existing poll
   * @param pollId - Poll ID
   * @param data - Poll update data
   * @returns Promise<PollResponse>
   */
  async updatePoll(pollId, data) {
    try {
      const response = await requests.put(`/polls/${pollId}`, data);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Delete a poll
   * @param pollId - Poll ID
   * @returns Promise<DeleteResponse>
   */
  async deletePoll(pollId) {
    try {
      const response = await requests.delete(`/polls/${pollId}`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Submit a vote for a poll
   * @param data - Vote data { pollId, participantId, participantName, optionIndices, timestamp }
   * @returns Promise<VoteResponse>
   */
  async submitVote(data) {
    try {
      const response = await requests.post(`/polls/${data.pollId}/vote`, data);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get poll results
   * @param pollId - Poll ID
   * @returns Promise<PollResultsResponse>
   */
  async getPollResults(pollId) {
    try {
      const response = await requests.get(`/polls/results/${pollId}`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getUserPolls() {
    try {
      const response = await requests.get(`/polls/user-polls`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Handle API errors
   * @param error - Error object
   * @returns Error with formatted message
   */
  handleError(error) {
    if (error.response?.data) {
      const { message, errors } = error.response.data;

      // Handle validation errors array
      if (Array.isArray(errors) && errors.length > 0) {
        return new Error(errors.join(", "));
      }

      // Handle validation errors object
      if (errors && typeof errors === "object" && !Array.isArray(errors)) {
        const errorMessages = Object.values(errors).flat();
        return new Error(errorMessages.join(", "));
      }

      if (message) {
        return new Error(message);
      }
    }

    if (error.message) {
      return new Error(error.message);
    }

    return new Error("An unexpected error occurred");
  }
}

// Export singleton instance
const pollServices = new PollServices();
export default pollServices;
